<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>积分充值清单</h1>
        <p>门户用户积分购买流水：充值账号、手机、平台、单号、时间、金额与对应积分。</p>
      </div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <input v-model="filters.startDate" type="date" @change="go(1)" />
        <span class="ch-note">至</span>
        <input v-model="filters.endDate" type="date" @change="go(1)" />
        <select v-model="filters.status" @change="go(1)">
          <option :value="1">已支付</option>
          <option :value="0">待支付</option>
          <option :value="2">已退款</option>
          <option value="">全部状态</option>
        </select>
        <button class="ch-btn" type="button" @click="go(1)">查询</button>
      </div>
      <table class="ch-table">
        <thead>
          <tr>
            <th>充值账号</th>
            <th>充值手机</th>
            <th>充值平台</th>
            <th>充值单号</th>
            <th>充值时间</th>
            <th>充值金额</th>
            <th>对应积分</th>
            <th>状态</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.orderNo || row.id">
            <td>{{ accountText(row) }}</td>
            <td>{{ row.userPhone || '—' }}</td>
            <td>{{ row.paymentMethodLabel || row.channel || '—' }}</td>
            <td class="mono">{{ row.orderNo || '—' }}</td>
            <td>{{ formatTime(row.paidAt || row.createdAt) }}</td>
            <td>¥ {{ formatMoney(row.amount) }}</td>
            <td>{{ pointsText(row) }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ row.statusLabel || '—' }}</span></td>
          </tr>
          <tr v-if="!list.length && !loading">
            <td colspan="8" class="ch-empty">暂无积分充值记录</td>
          </tr>
          <tr v-if="loading">
            <td colspan="8" class="ch-empty">加载中…</td>
          </tr>
        </tbody>
      </table>
      <div class="ch-filters" style="margin-top:12px">
        <button class="ch-btn" type="button" :disabled="page <= 1 || loading" @click="go(page - 1)">上一页</button>
        <span class="ch-note">第 {{ page }} / {{ pages }} 页 · 共 {{ total }} 笔</span>
        <button class="ch-btn" type="button" :disabled="page >= pages || loading" @click="go(page + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayOrders } from '@/api/admin'

function todayStr() {
  const d = new Date()
  const m = `${d.getMonth() + 1}`.padStart(2, '0')
  const day = `${d.getDate()}`.padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

function monthStartStr() {
  const d = new Date()
  const m = `${d.getMonth() + 1}`.padStart(2, '0')
  return `${d.getFullYear()}-${m}-01`
}

export default {
  name: 'HqPointRecharges',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: {
        startDate: monthStartStr(),
        endDate: todayStr(),
        status: 1
      }
    }
  },
  computed: {
    pages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatMoney(v) {
      return Number(v || 0).toFixed(2)
    },
    formatTime(v) {
      return v ? String(v).replace('T', ' ').slice(0, 19) : '—'
    },
    accountText(row) {
      const name = row.userName || ''
      const id = row.userId != null ? `ID:${row.userId}` : ''
      if (name && id) return `${name}（${id}）`
      return name || id || '—'
    },
    pointsText(row) {
      if (row.points != null && row.points !== '') {
        return Number(row.points).toLocaleString('zh-CN')
      }
      const detail = String(row.purchaseDetail || '')
      const m = detail.match(/(\d[\d,]*)/)
      return m ? m[1] : '—'
    },
    tagOf(status) {
      if (Number(status) === 1) return 'ok'
      if (Number(status) === 2) return 'warn'
      return ''
    },
    go(p) {
      this.page = Math.max(1, p)
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const data = await getPayOrders({
          startDate: this.filters.startDate,
          endDate: this.filters.endDate,
          orderType: 'point',
          status: this.filters.status === '' ? undefined : this.filters.status,
          page: this.page,
          pageSize: this.pageSize
        })
        this.list = data?.list || []
        this.total = Number(data?.total || 0)
      } catch (e) {
        this.list = []
        this.total = 0
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-size: 12px; }
</style>
